var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"app"}},[(_vm.configLoaded)?[_c('global-alerts'),_c('global-dialog'),_c('v-main',[_c('router-view')],1),_c('app-footer')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }